import {TemplateRef, ViewEncapsulation} from '@angular/core';
import {Inject, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {MainService} from 'src/app/Services/service.service';
import {DTOConversationImage, DTOConversation, DTOConversationMessage} from './../../../../api/WickedApiClient';
import {Moment} from 'moment';
import {Component, OnInit, Input} from '@angular/core';
import {User} from '../user-image/user-image.component'
import {NgxSwiperConfig} from 'ngx-image-swiper';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'vng-chat-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageComponent implements OnInit {

  @ViewChild('imageDialog', {static: true}) public imageDialogRef: TemplateRef<any>;

  swiperConfig: NgxSwiperConfig;
  images: string[] = [];
  messageNick: string = "";

  constructor(private mainService: MainService, public dialog: MatDialog) { }

  @Input() message: DTOConversationMessage;
  @Input() conversation: DTOConversation;

  ngOnInit() {
    if(this.message.images.length > 0) {
      if(this.images[this.conversation.conversationId] == null) {
        this.images = []
      }
      this.images = this.prepareImages(this.message);
    }
    this.swiperConfig = {
      navigationPlacement: 'inside',
      pagination: this.images.length > 1 ? true : false,
      paginationPlacement: 'outside',
      imgBackgroundSize: 'contain'
    };
    this.messageNick = this.resolveMessageSenderNick(this.conversation, this.message);
  }

  formatDate(date) {
    return date.format("MM/DD/YYYY hh:mm A");
  }

  getUser() {
    return {
      name: "lolek",
      picture: 'https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/gettyimages-1038241336a-1587582575.jpg?crop=1.00xw:0.669xh;0,0.0833xh&resize=640:*',
      status: 'online',
      color: "red"
    }
  }

  resolveMessageSenderNick(conversation: DTOConversation, message: DTOConversationMessage) {
    if(message.senderId == this.mainService.userService.getUserId()) {
      return "You"
    }
    else {
      if(conversation.senderId == message.senderId) {
        return conversation.senderNick
      }
      else return conversation.receiverNick;
    }
  }

  hasImages(conversationIndex: number, messageIndex: number): boolean {
    return this.images != null && this.images.length > 0;
  }

  prepareImages(message: DTOConversationMessage): string[] {
    var images = message.images.map(img => {
      return `${environment.apiBaseUrl}/FileGet/${img.fileName}`;
    });

    return images;
  }

  openDialog(imageUrl): void {
    const dialogRef = this.dialog.open(this.imageDialogRef, {
      width: '90%',
      data: imageUrl,
      backdropClass: "imageDialog__backdrop",
      panelClass: "imageDialog__panel"
    });
  }

  imageClick(imageIndex) {
    this.openDialog(this.images[imageIndex]);
  }
}
